import { useCallback } from 'react';
import { State } from 'store/types';
import { useStoreon } from 'storeon/react';
import { CITY_PICKER_HINT, CITY_PICKER_MENU, REGIONS_MENU } from 'actions';

export interface UseCityPickerStateReturnType {
  show: boolean;
  regionsShow: boolean;
  hintShow: boolean;
  onMenuOpen: () => void;
  onMenuClose: () => void;
  onRegionsMenuOpen: () => void;
  onRegionsMenuClose: () => void;
  onHintOpen: () => void;
  onHintClose: () => void;
}

export const useCityPickerState = (): UseCityPickerStateReturnType => {
  const { dispatch, headerDrawers } = useStoreon<State>('headerDrawers');

  const onMenuOpen = useCallback(() => dispatch(CITY_PICKER_MENU.openDrawer), [dispatch]);
  const onMenuClose = useCallback(() => dispatch(CITY_PICKER_MENU.closeDrawer), [dispatch]);
  const onHintClose = useCallback(() => dispatch(CITY_PICKER_HINT.closeHint), [dispatch]);
  const onHintOpen = useCallback(() => dispatch(CITY_PICKER_HINT.openHint), [dispatch]);
  const onRegionsMenuOpen = useCallback(() => dispatch(REGIONS_MENU.openDrawer), [dispatch]);
  const onRegionsMenuClose = useCallback(() => dispatch(REGIONS_MENU.closeDrawer), [dispatch]);

  return {
    show: headerDrawers.cityPickerVisible,
    regionsShow: headerDrawers.regionsMenuVisible,
    hintShow: headerDrawers.hintShow,
    onMenuClose,
    onMenuOpen,
    onRegionsMenuOpen,
    onRegionsMenuClose,
    onHintOpen,
    onHintClose,
  };
};
